import { OrdersDataGrid } from "./Orders";
import UnarchiveOutlinedIcon from '@mui/icons-material/UnarchiveOutlined';
import { query } from "../App";
import KeyIcon from '@mui/icons-material/Key';

export default function Archive() {
    return (<OrdersDataGrid
        filterData={undefined}
        queryPath="/archive"
        editButton={false}
        additionalActionButtons={[
            {
                icon: UnarchiveOutlinedIcon, iconTooltip: `Przywróć do zamówień id: *id*`, label: "UnArchive", onClick: async (id) => {
                    await query(`/archive/release/order/${id}`, 'PATCH');
                    window.location.reload();
                }
            },
            {
                icon: KeyIcon, iconTooltip: `Karta technologiczna id: *id*`, label: "TechCard", onClick: async (id) => {
                    window.open('https://produkcja.patentdruk.pl/admin_panel/checkStatus/StatusTable/?nr_zam=' + id, '_blank');
                }
            },
        ]} />)
}